import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { EditUserRoleAccessInsideUsersPageService } from "../../services/UserOnboardingService";

const UserEditRolesAccessPage = ({
  userRolesAccessDetails,
  userId,
  setLoading,
  showNotification,
  handleClose,
  openDialog,
  loginUserInfo,
}) => {
  const [payload, setPayload] = useState([]);
  const [temp, setTemp] = useState([]);

  function createPayload(data) {
    const newRecords = {
      userId: userId,
      accessPermissionParamList: [],
    };
    data &&
      data.forEach((item) => {
        item["permissionStatusResponseList"].forEach((i) => {
          newRecords.accessPermissionParamList.push({
            accessDataTypeId: item.accessDataTypeId,
            permId: i.permissionId,
            active: i.active,
          });
        });
      });
    setPayload(newRecords);
  }

  useEffect(() => {
    createPayload(userRolesAccessDetails);
    setTemp(userRolesAccessDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRolesAccessDetails]);

  const handleChange = (e, a, p) => {
    const t = [];
    temp.forEach((item) => {
      if (item?.accessDataTypeId === a) {
        t.push({
          accessDataTypeId: a,
          accessDataTypeName: item.accessDataTypeName,
          permissionStatusResponseList: item[
            "permissionStatusResponseList"
          ].map((i) => {
            return {
              permissionId: i.permissionId,
              permissionName: i.permissionName,
              active: i.permissionId === p ? e.target.checked : i.active,
            };
          }),
        });
      } else {
        t.push(item);
      }
    });
    setTemp(t);
    createPayload(t);
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await EditUserRoleAccessInsideUsersPageService(payload);
      if (response.statusCode === 6) {
        handleClose(false);
        showNotification("Success", response.message, "success");
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };
  const onResetDetails = () => {
    createPayload(userRolesAccessDetails);
    setTemp(userRolesAccessDetails);
  };

  return (
    <Dialog open={openDialog} onClose={handleClose}>
      <DialogTitle
        sx={{ backgroundColor: "#003f93", color: "#ffffff", fontSize: "16px" }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <b>Edit User Rights</b>
          </div>
          <CloseIcon
            className="pageHeader"
            onClick={handleClose}
            style={{ cursor: "pointer", color: "white" }}
          />
        </Box>
      </DialogTitle>
      {/* <Typography align="left"  sx={{mb:-1, marginLeft:3, mt:1 }} >
            <div>
              <p>user name, user code, user department, user id   </p>
            </div>
      </Typography> */}
      <Grid item xs={12} mb={0} sx={{ marginRight: 2, marginLeft: 2 }}>
        {userRolesAccessDetails && userRolesAccessDetails.length > 0 ? (
          <Paper sx={{ width: "100%", overflow: "hidden", margin: "10" }}>
            <TableContainer>
              <Table
                stickyHeader
                aria-labelledby="tableTitle"
                sx={{ maxWidth: 680 }}
                size="small"
                aria-label="a dense table"
              >
                <TableBody sx={{ mt: 1 }}>
                  {userRolesAccessDetails.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={index}
                        sx={{ maxHeight: 650 }}
                      >
                        <TableCell size="small" key={"accessDataTypeName"}>
                          {row["accessDataTypeName"] ?? "-"}
                        </TableCell>
                        {row["permissionStatusResponseList"].map((r, i) => {
                          return (
                            <TableCell size="small" key={i + Date.now()}>
                              <Checkbox
                               classes={{root: 'custom-checkbox-root'}}
                                checked={
                                  payload?.accessPermissionParamList?.filter(
                                    (item) =>
                                      item.accessDataTypeId ===
                                        row["accessDataTypeId"] &&
                                      item.permId === r["permissionId"]
                                  )[0]?.active
                                }
                                onChange={
                                  loginUserInfo.userType !== "Domain Admin"
                                    ? (e) =>
                                        handleChange(
                                          e,
                                          row["accessDataTypeId"],
                                          r["permissionId"]
                                        )
                                    : null
                                }
                              />
                              {r["permissionName"]}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        ) : (
          <Paper elevation={3} variant="elevation">
            {/* <RecordNotFound /> */}
          </Paper>
        )}
      </Grid>
      {loginUserInfo.userType !== "Domain Admin" ? (
        <Typography align="right" sx={{ mb: 2, marginRight: 1, mt: 2 }}>
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{ p: 1, mr: 1 }}
            className="button-primary-alt-contained"
          >     
            Save
          </Button>
          <Button
            variant="contained"
            onClick={() => onResetDetails()}
            sx={{ p: 1, mr: 1 }}
            className="button-primary-alt-contained"
          >
            {" "}
            Reset
          </Button>
        </Typography>
      ) : null}
    </Dialog>
  );
};

export default UserEditRolesAccessPage;
